import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home/home.service';
import {
  Division,
  IDiversities,
  ILocation,
  IPyramids,
  TalentChartData,
} from './team-utilization.interface';

@Component({
  selector: 'app-team-utilization',
  templateUrl: './team-utilization.component.html',
  styleUrls: ['./team-utilization.component.scss'],
})
export class TeamUtilizationComponent implements OnInit {
  constructor(
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}
  public headCount!: number;
  public diversity!: Division[];
  public pyramids!: Division[];
  public location!: Division[];
  teamUtilization:number = 0;
  currentActiveTab = 'division';
  chartWidth = 150;
  chartHeight = 150;
  talentChartData: TalentChartData[] = [
    {
      id: 1,
      color: '#7f7f91',
      value: 0,
    },
    {
      id: 2,
      color: '#444ce7',
      value: 0
    },
  ];
  tabs = [
    {
      id: 1,
      label: 'Division',
      name: 'division',
      active: true,
    },
    {
      id: 2,
      label: 'Promotion & Progression',
      name: 'promotionProgression',
      active: false,
    },
    {
      id: 3,
      label: 'Hiring & Attrition',
      name: 'hiringAttrition',
      active: false,
    },
    {
      id: 4,
      label: 'Training & Certification',
      name: 'trainingCertification',
      active: false,
    },
  ];

  tabClickHandler(tabObj: any): void {
    this.currentActiveTab = tabObj.name;
    this.tabs.forEach((tab) => {
      tab.active = tab.name === tabObj.name;
    });
  }

  getPercentage(count: number, headCount: number) {
    return Math.round((count / headCount) * 100);
  }
  ngOnInit(): void {
    // const id = this.route.snapshot.paramMap.get('id');
    this.homeServiceRef.getEngagementId().subscribe(enagementId=>{
      const id = enagementId;
      if (id) {
        this.homeServiceRef.getTalentManagement(id).subscribe((res) => {
          if (res) {
            this.headCount = res.headCount;
            this.teamUtilization = res.teamUtilization;
            this.talentChartData[0].value = 100 - res.teamUtilization;
            this.talentChartData[1].value = res.teamUtilization;
            this.diversity = res.diversities.map(
              (diversity: IDiversities, index: number) => {
                return {
                  id: index + 1,
                  label: diversity.gender.charAt(0).toUpperCase(),
                  value: this.getPercentage(diversity.count, res.headCount),
                  count: diversity.count,
                };
              }
            );
            this.pyramids = res.pyramids.map(
              (pyramid: IPyramids, index: number) => {
                return {
                  id: index + 1,
                  value: this.getPercentage(pyramid.count, res.headCount),
                  name:pyramid.rankName,
                  count: pyramid.count,
                };
              }
            );
            this.location = res.location.map((loc: ILocation, index: number) => {
              return {
                id: index + 1,
                value: this.getPercentage(loc.count, res.headCount),
                name:loc.name,
                count: loc.count,
              };
            });
          }
        });
      }
    });
  }
}
